import { render, staticRenderFns } from "./CreditScore.vue?vue&type=template&id=6f621ee2&"
import script from "./CreditScore.vue?vue&type=script&lang=js&"
export * from "./CreditScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreditScore.vue"
export default component.exports